<template>
  <v-container>
    <page-header :title="range" :info="lang.yearsInfo(range)" />
    <grid :items="items" :headers="headers" />
    <div hidden v-if="range" v-html="lang.yearsInfo(range)" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'
import data from '../helpers/data'

export default {
  name: 'years-range',
  mixins: [
    data,
    methods
  ],
  data () {
    return {
      lang,
      range: null
    }
  },
  watch: {
    /**
     * route.params.range watcher
     */
    '$route.params.range' () {
      this.getYearsConfig()
    }
  },
  mounted () {
    this.getYearsConfig()
  },
  methods: {
    /**
     * Get the page data from the API
     * @method getYearsConfig
     * @return {void}
     */
    getYearsConfig () {
      this.range = this.$route.params.range
      this.getTabularData('years', this.range, 'range', () => {
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.range)
        })
      })
      this.$nextTick(() => {
        this.emitRouteChange()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/years-range.vue